import { render, staticRenderFns } from "./ConsentDecisionPanel.vue?vue&type=template&id=82e56bfe&scoped=true"
import script from "./ConsentDecisionPanel.vue?vue&type=script&lang=js"
export * from "./ConsentDecisionPanel.vue?vue&type=script&lang=js"
import style0 from "./ConsentDecisionPanel.vue?vue&type=style&index=0&id=82e56bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e56bfe",
  null
  
)

export default component.exports